import React, { useState } from 'react';
import '../styles/Services.css'; 
const services = [
  {
    title: 'CONSEIL ET FORMATION',
    short: 'Préparation technique, formation navigation...',
    details: 'Préparation technique\nFormation navigation\nAide à la prise en main',
    image: "/images/Frederic-Switala_Meta-Yachts-Services.jpg" ,
  },
  {
    title: 'PRÉPARATION GRANDE CROISIÈRE',
    short: 'Transformation, refit aluminium, composite...',
    details: 'Transformation & Refit\nAluminium / Composite',
    image: '/images/Carene1.jpg',
  },
  {
    title: 'PRÉPARATION COQUE & PONT',
    short: 'META-Grip, enduits MAP Yachting...',
    details: 'Applicateur META-Grip\nPrimaires et enduits MAP Yachting\nAntidérapant DECKLINE\nLustrage Polish',
    image: '/images/AntiDerapant.jpg',
  },
  {
    title: 'TRAVAUX DE MÉTALLERIE',
    short: 'Soudure alu/inox, portiques, casquettes...',
    details: 'Soudure alu / inox\nSoudure & décapage laser\nCréation portique / casquette / bimini',
    image: '/images/Coque-Chantier_Meta-Yachts-Services-scaled.jpg',
  },
  {
    title: 'GRÉEMENT & VOILES',
    short: 'Dormant, courant, textile, voiles...',
    details: 'Dormant / Courant / Textile\nVoiles\nAccastillage',
    image: '/images/Voilecasse.jpg',
  },
  {
    title: 'NETTOYAGE & CONCIERGERIE',
    short: 'Nettoyage intérieur, hivernage, conciergerie...',
    details: 'Intérieur / Extérieur\nConciergerie\nHivernage / Thermobachage',
    image: '/images/Bachage+Sablage.jpg',
  },
];

const VoyagezAvecNous = () => {
  const [activeService, setActiveService] = useState(null);

  return (
    <section className="services-container">
      <h1 className="section-title">Voyagez <span>avec nous</span></h1>
      <div className="grid">
        {services.map((service, index) => (
          <div className="card" key={index} onClick={() => setActiveService(service)}>
            <img src={service.image} alt={service.title} />
            <div className="card-content">
              <h3>{service.title}</h3>
              <p>{service.short}</p>
            </div>
          </div>
        ))}
      </div>

      {activeService && (
        <div className="modal" onClick={() => setActiveService(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setActiveService(null)}>✖</button>
            <h3>{activeService.title}</h3>
            <p className="details">{activeService.details}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default VoyagezAvecNous;